

import axios from 'axios';
const basicAuth = "dialogix"; 

//export const whatsappapi = 'http://72.60.220.34:3001';
export const whatsappapi = 'https://nodeapi.dialogix.cloud:3001';

const axiosInstance = axios.create({
  baseURL: 'https://apidialogix.kanhaiya.co.in/index.php/',
  timeout: 20000
});
export const mediaURL = "https://apidialogix.kanhaiya.co.in/uploads/";


axiosInstance.interceptors.request.use(
  (config) => {
    config.headers['Basic'] = basicAuth;
    if (config.data instanceof FormData) {
      config.headers['Content-Type'] = 'multipart/form-data';
    } else if (!config.headers['Content-Type']) {
      config.headers['Content-Type'] = 'application/json';
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    return Promise.reject(error);
  }
);
export default axiosInstance;